<h1 class="page-title">Add Course</h1>
<app-course-editor></app-course-editor>